import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-image-accept',
  templateUrl: './modal-image-accept.component.html',
  styleUrls: ['./modal-image-accept.component.css']
})
export class ModalImageAcceptComponent implements OnInit {
  image: any;
  image_name: string;
  constructor(@Inject(MAT_DIALOG_DATA)
    public data: any, public dialogRef: MatDialogRef<ModalImageAcceptComponent>) { }


  ngOnInit() {
    this.readThis(this.data)
  }
  readThis(inputValue: any): void {

    const file: File = inputValue.files[0];
    this.image_name=file.name;
    const myReader: FileReader = new FileReader();

    myReader.onloadend = () => {
      this.image = myReader.result
    }
    myReader.readAsDataURL(file);
  }

  send(){
    const imagesplit= this.image.split(",")
    this.dialogRef.close({
      image_name: this.image_name,
      image: imagesplit[1]
    });
  }
}
